import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './ItemPreview.css';
import SliderGalleryItem from '../../models/SliderGalleryItem';

const ItemPreview = ({ item }) => {
  return (
    <Link to={item.linkTo} className="itemPreview">
      <img src={item.imagePath} alt={item.title} className="itemPreview-image" />
      <p className="itemPreview-title" title={item.title}>
        {item.title || '(Unknown)'}
      </p>
      <p className="itemPreview-subtitle" title={item.subtitle}>
        {item.subtitle || '\u00A0'}
      </p>
    </Link>
  );
};

ItemPreview.propTypes = {
  item: PropTypes.instanceOf(SliderGalleryItem).isRequired,
};

export default ItemPreview;



// WEBPACK FOOTER //
// ./src/components/common/ItemPreview.jsx